import React from 'react';
import { Link } from 'react-router-dom';

const Media = () => {
  return (
    <>
      <h1>Media page</h1>
      <Link to="signup/coach">go to signup page</Link>
    </>
  );
};

export default Media;
